"use client";

export default function GoogleTranslate() {
  return (
    <>
      <div className="order-first" id="google_translate_element" />
    </>
  );
}
